/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import DefaultPredicateComparisonOptions from 'predicates/models/data/default-predicate-comparison-options';
const NUMERIC_COMPARISONS = {
  comparison: [{
    label: 'is greater than',
    value: 'gt'
  }, {
    label: 'is less than',
    value: 'lt'
  }, {
    label: 'is',
    value: 'eq'
  }, {
    label: 'is not',
    value: 'ne'
  }, {
    label: 'is increased',
    value: 'increase'
  }, {
    label: 'is decreased',
    value: 'decrease'
  }, {
    label: 'has any value',
    value: 'known'
  }]
};
const SELECT_COMPARISONS = {
  comparison: [{
    label: 'is',
    value: 'eq'
  }, {
    label: 'is not',
    value: 'ne'
  }, {
    label: 'has any value',
    value: 'known'
  }]
};
const CustomComparisonOptions = {
  custom: {
    session_count: {
      numeric: {
        comparison: [{
          label: 'is greater than',
          value: 'gt'
        }, {
          label: 'is less than',
          value: 'lt'
        }, {
          label: 'is',
          value: 'eq'
        }, {
          label: 'is not',
          value: 'ne'
        }, {
          label: 'is increased',
          value: 'increase'
        }, {
          label: 'has any value',
          value: 'known'
        }]
      }
    }
  },
  date: {
    comparison: [{
      label: 'has any value',
      value: 'known'
    }],
    months: DefaultPredicateComparisonOptions.date.months
  },
  string: {
    comparison: [{
      label: 'is',
      value: 'eq'
    }, {
      label: 'is not',
      value: 'ne'
    }, {
      label: 'starts with',
      value: 'starts_with'
    }, {
      label: 'ends with',
      value: 'ends_with'
    }, {
      label: 'contains',
      value: 'contains'
    }, {
      label: 'contains exact word',
      value: 'contains_exact_word'
    }, {
      label: 'does not contain',
      value: 'not_contains'
    }, {
      label: 'has any value',
      value: 'known'
    }]
  },
  numeric: NUMERIC_COMPARISONS,
  select: SELECT_COMPARISONS,
  optionalSelect: SELECT_COMPARISONS
};
let mergedOptions = Object.assign({}, DefaultPredicateComparisonOptions, CustomComparisonOptions);
export default mergedOptions;